import { atom, useRecoilState } from 'recoil';

/**
 * @description 페이지 로딩 상태관리
 */

// atom
const pageLoadingState = atom({
  key: 'pageLoadingState',
  default: false
});

// hook
function usePageLoadingState() {
  const [pageLoading, setPageLoading] = useRecoilState(pageLoadingState);
  return { pageLoading, setPageLoading };
}

export { usePageLoadingState };
